import { BlockTitle } from "@blocks/Blocks";

import BenefitsSection from "./BenefitsSection";
import InternationalSection from "./InternationalSection";
import JudgingCriteriaSection from "./JudgingCriteriaSection";
import LaunchSection from "./LaunchSection";
import NominationsCriteriaSection from "./NominationsCriteriaSection";
import ObjectivesSection from "./ObjectivesSection";
import WinningLimitsSection from "./WinningLimitSection";

/**
 * Component to render About section for FAQ Page
 */
const AboutSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="About the Awards"
        rootClassName="bg-gray-150 text-2xl md:text-2xl lg:text-2xl font-semibold pb-2 pt-4 pl-4 font-public-sans"
      />

      <ObjectivesSection />

      <LaunchSection />

      <NominationsCriteriaSection />

      <JudgingCriteriaSection />

      <BenefitsSection />

      <WinningLimitsSection />

      <InternationalSection />
    </>
  );
};

export default AboutSection;
